module.exports = __webpack_public_path__ + "img/security.1e9dea90.svg";